const baseUrl = 'https://static.molo.com/';
//
// const baseUrl = 'https://b2b.molo.com/';

function withTrailingSlash(u: string): string {
    const t = u.trim();
    if (!t) {
        return t;
    }
    return t.endsWith('/') ? t : t + '/';
}

function trimTrailingSlashUrl(u: string): string {
    return u.replace(/\/+$/, '');
}

/** Same origin as before `cdnImageBaseUrl` split — legacy `media.baseUrl`. */
const legacyMediaBaseUrl =
    process.env.NODE_ENV !== 'production' ? baseUrl : baseUrl + '/';

export const appConfig = {
    api: {
        baseUrl: process.env.NODE_ENV !== 'production' ? baseUrl + 'api/' : '/api/',
    },
    media: {
        /** @deprecated for new product JPGs — prefer `cdnImageBaseUrl` + productImageUrl helper. Kept for any legacy callers. */
        baseUrl: legacyMediaBaseUrl,

        /** CDN root for static product images: `{cdn}{season}/{master}_{color}.jpg` */
        cdnImageBaseUrl: withTrailingSlash(
            process.env.REACT_APP_CDN_IMAGE_BASE_URL != null &&
                process.env.REACT_APP_CDN_IMAGE_BASE_URL !== ''
                ? process.env.REACT_APP_CDN_IMAGE_BASE_URL
                : baseUrl
        ),

        /** Legacy media API base (unused by pack gallery; kept for env compatibility). */
        imageMapApiBaseUrl: withTrailingSlash(
            process.env.REACT_APP_IMAGE_MAP_API_BASE_URL != null &&
                process.env.REACT_APP_IMAGE_MAP_API_BASE_URL !== ''
                ? process.env.REACT_APP_IMAGE_MAP_API_BASE_URL
                : legacyMediaBaseUrl
        ),

        /** Base for `GET …/{season}/{style}/index.json?format=compact` (pack gallery). */
        packsApiBaseUrl: withTrailingSlash(
            process.env.REACT_APP_PACKS_API_BASE_URL != null &&
                process.env.REACT_APP_PACKS_API_BASE_URL !== ''
                ? process.env.REACT_APP_PACKS_API_BASE_URL
                : process.env.REACT_APP_PACKS_VARIANT_API_BASE_URL != null &&
                    process.env.REACT_APP_PACKS_VARIANT_API_BASE_URL !== ''
                  ? process.env.REACT_APP_PACKS_VARIANT_API_BASE_URL
                  : 'https://assets.molo.com/'
        ),

        /** Query param name when not using raw thumb/large strings (default `profile`). */
        imageQueryParam: process.env.REACT_APP_IMAGE_QUERY_PARAM || 'profile',
        imageProfileThumb: process.env.REACT_APP_IMAGE_PROFILE_THUMB || 'b2bthumb',
        imageProfileLarge: process.env.REACT_APP_IMAGE_PROFILE_LARGE || 'b2blarge',

        /**
         * Optional raw query for thumb/large (without `?`). Empty string => no query for that size.
         * When set (non-empty), overrides `imageQueryParam` + profile value for that variant.
         */
        imageQueryThumbRaw: process.env.REACT_APP_IMAGE_QUERY_THUMB,
        imageQueryLargeRaw: process.env.REACT_APP_IMAGE_QUERY_LARGE,
    },
};

/** Per-style compact pack index. Fx `https://assets.molo.com/w25/1w25a201/index.json?format=compact`. */
export function b2bPacksStyleIndexUrl(seasonCode: string, styleCode: string): string {
    const base = trimTrailingSlashUrl(appConfig.media.packsApiBaseUrl);
    const season = String(seasonCode || '').trim().toLowerCase();
    const style = String(styleCode || '').trim().toLowerCase();
    return (
        base +
        '/' +
        encodeURIComponent(season) +
        '/' +
        encodeURIComponent(style) +
        '/index.json?format=compact'
    );
}
